<template>
    <v-container>
        <v-row class="pt-0">
            <v-col cols="12">
                <v-text-field small :append-icon="icons.search" label="Search" v-model="search" />
            </v-col>
            <v-col cols="12" class="pa-0">
                <v-data-table
                :headers="headers"
                :items="$store.state[groupstatus]"
                v-model="selected"
                item-key="groupkey"
                :search="search"
                :show-select="checks"
                @click:row="callback($event)"
                ></v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import{
      mapState
    } from 'vuex'
  export default {
    props:['callback','groups','checks'],
    components: {},
    name: "GroupList",
    data() {
      return {
        headers:[
          {text:'Name', value:'name', align: 'text-left'},
          {text: 'Total', value: 'total', align: 'text-left'}
        ],
        g:undefined,
        selected:[],
        toemit:{},
        search:''
      }
    },
    mounted() {
        this.selected = this.$store.state.selectedgroups
    },
    computed:{
      ...mapState(['groupstatus','icons'])
    },
    watch:{
      selected(n){
        this.$store.commit('setSelectedGroups',n)
      }
    },
    methods: {
      async openGroup(g){
        await this.$store.dispatch('getGroup',g.sortkey);
      },
      emitSelected(){
        let em = this;
        Object.keys(this.selected).forEach(function(k){
          if(em.selected[k]){
            em.toemit[k] = em.$store.state.groups[k]
          }
        })
        this.$store.commit('setSelectedGroups',this.toemit)
      },
      fakecallback(){return;},
      getAllArchived () {
        let em = this;
        em.loading1=true
        let args = {
          url:this.$store.state.url + 'api/groups/archivedv2/'+this.$store.state.org.partkey,
          method:"GET"
        }
        this.$store.dispatch('fetch',args).then(res=>{
          em.$store.commit('setArchivedGroups',res)
          em.groups='archivedgroups'
          em.loading1=false
        }).catch(e=>{
          return e
        })
      },
      //TODO newly added functions to this component.. change to use them here.
      getAllActive(){
        let em = this;
        this.loading2=true
        let args = {
          url:this.$store.state.url + 'api/groups/allv2/' + this.$store.state.org.partkey,
          method:"GET"
        }
        this.$store.dispatch('fetch',args)
            .then((res)=>{
              em.$store.commit('setGroups', res.Item.contactgroups)
              em.groups='groups'
              em.loading2=false
            }).catch(e=> {return e} );

      }
    }
  }
</script>

<style scoped>

</style>